import moment from 'moment';

export const monitorMsgType = {
    0: '未知',
    1: '与客户沟通',
    2: '与同事沟通',
    3: '群内沟通',
};

export const degreeConfig = {
    0: '未知',
    1: '消息拦截',
    2: '仅提示或告警',
    3: '仅留存记录',
    4: '替换型',
};


export const recordsColumns = [
    {
        label: '触发账号',
        columnKey: 'account',
        render(h, props) {
            return (
                <span>{ props.row.from?.name || '' }（{ props.row.from?.uin || '' }）</span>
            );
        },
        width: 230,
    },
    {
        label: '敏感词',
        columnKey: 'matched_words',
        render(h, props) {
            return (
                <div class="records-table__tag">
                    <span>{  props.row.matched_words || '' }</span>
                </div>
            );
        },
        width: 120,
    },
    {
        label: '规则名',
        columnKey: 'ruleName',
        render(h, props) {
            return (
                <span>{ props.row.rule?.name || '' }</span>
            );
        },
    },
    {
        label: '消息内容',
        columnKey: 'message_content',
    },
    {
        label: '监控消息类型',
        columnKey: 'type',
        render(h, props) {
            return (
                <span>{monitorMsgType[props.row.channel]}</span>
            );
        },
        width: 120,
    },
    {
        label: '告警程度',
        columnKey: 'degree',
        render(h, props) {
            return (
                <span>{ degreeConfig[props.row.action || 0] }</span>
            );
        },
        width: 120,
    },
    {
        label: '消息接收方',
        columnKey: 'receiver',
        render(h, props) {
            return (
                <span>与{ props.row.to?.name || '' }（{ props.row.to?.uin || '' }）的聊天</span>
            );
        },
    },
    {
        label: '触发时间',
        columnKey: 'hit_time',
        render(h, props) {
            return (
                <span>{moment(props.row.hit_time * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
            );
        },
    },
];
